import { sha256 } from "js-sha256";
import { useCallback } from "react";

export const useTikTokPixel = () => {
  const trackEvent = useCallback(({ eventName, properties = {} }) => {
    if (typeof window !== "undefined" && window?.ttq) {
      window.ttq.track(eventName, properties);
    }
  }, []);

  const identify = useCallback(({ email, phone_number, external_id }) => {
    // console.debug("email", email);
    // console.debug("phone_number", phone_number);
    // console.debug(
    //   "sha256(email.toLowerCase().trim())",
    //   email ? sha256(email.toLowerCase().trim()) : ""
    // );
    // console.debug(
    //   "sha256(phone_number.trim())",
    //   phone_number ? sha256(phone_number.trim()) : ""
    // );
    if (typeof window !== "undefined" && window?.ttq) {
      window.ttq.identify({
        email: email ? sha256(email.toLowerCase().trim()) : "",
        phone_number: phone_number ? sha256(phone_number.trim()) : "",
        external_id,
      });
    }
  }, []);

  return {
    isHaveTikTokPixel: !!process.env.REACT_APP_TIKTOK_PIXEL_CODE,
    trackEvent,
    identify,
  };
};
